<template>
  <div>
    <home-no-data></home-no-data>
  </div>
</template>

<script>
import HomeNoData from '@/components/news-monitor/HomeNoData';

export default {
  components: {
    HomeNoData
  }
};
</script>


